module.exports = __webpack_public_path__ + "content/352b328d8914e36c20faf15bfacd262a.png";